import imagesSVG from '@plone/volto/icons/images.svg';
import listBulletSVG from '@plone/volto/icons/list-bullet.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';

import MpfSubHomeCarrosselBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/SubHomeCarrossel/Edit';
import MpfSubHomeCarrosselBlockView from 'volto-ministerio-publico-federal/components/Blocks/SubHomeCarrossel/View';
import { SubHomeCarrosselBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/SubHomeCarrossel/adapter';
import MpfSubHomeDestaqueBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/SubHomeDestaque/Edit';
import MpfSubHomeDestaqueBlockView from 'volto-ministerio-publico-federal/components/Blocks/SubHomeDestaque/View';
import { SubHomeDestaqueBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/SubHomeDestaque/adapter';
import MpfSubHomeGaleriaBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/SubHomeGaleria/Edit';
import MpfSubHomeGaleriaBlockView from 'volto-ministerio-publico-federal/components/Blocks/SubHomeGaleria/View';

import { GROUP_SUBHOME } from './groups';

/** Blocos das sub-homes (as capas de seção). */
export const subHomeBlocks = {
  mpfSubHomeCarrossel: {
    id: 'mpfSubHomeCarrossel',
    title: 'Carrossel de destaques (sub-home)',
    icon: sliderSVG,
    group: GROUP_SUBHOME,
    view: MpfSubHomeCarrosselBlockView,
    edit: MpfSubHomeCarrosselBlockEdit,
    dataAdapter: SubHomeCarrosselBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfSubHomeDestaque: {
    id: 'mpfSubHomeDestaque',
    title: 'Destaque (sub-home)',
    icon: listBulletSVG,
    group: GROUP_SUBHOME,
    view: MpfSubHomeDestaqueBlockView,
    edit: MpfSubHomeDestaqueBlockEdit,
    dataAdapter: SubHomeDestaqueBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfSubHomeGaleria: {
    id: 'mpfSubHomeGaleria',
    title: 'Carrossel de imagens (sub-home)',
    icon: imagesSVG,
    group: GROUP_SUBHOME,
    view: MpfSubHomeGaleriaBlockView,
    edit: MpfSubHomeGaleriaBlockEdit,
    mostUsed: false,
    sidebarTab: 1,
  },
};

export default subHomeBlocks;
